import type { TextareaHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
}

export function Textarea({
  id,
  label,
  hint,
  error,
  className,
  rows = 4,
  ...rest
}: TextareaProps) {
  const inputId = id ?? rest.name;
  return (
    <div className={styles.field}>
      {label ? (
        <label className={styles.fieldLabel} htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <textarea
        id={inputId}
        rows={rows}
        className={cn(styles.control, error && styles.controlError, className)}
        aria-invalid={error ? true : undefined}
        {...rest}
      />
      {error ? <div className={styles.fieldError}>{error}</div> : null}
      {!error && hint ? <div className={styles.fieldHint}>{hint}</div> : null}
    </div>
  );
}
